import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";

import { selectedOfferSelector } from "../../../selectors";

import "./styles.scss";
import Form from "./Form";

class KafeneAgreement extends Component {
  state = {
    additionalData: {},
    valid: false,
  };

  submitForm = (e) => {
    const { valid } = this.state;
    const { selectOffer, selectedOffer } = this.props;
    e.preventDefault();
    if (valid) {
      selectOffer({
        selectedOffer: {
          ...selectedOffer,
          agreementInfo: this.state.additionalData,
        },
      });
    }
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid,
    });
  };

  render() {
    const { loading } = this.props;
    const { valid } = this.state;

    return (
      <div className="form-container">
        <div className="bank-data-form-header">
          <h1 className="mt-12">Agreements</h1>
        </div>
        <Form onDataChange={this.setAdditionalData} />
        <BlueBtn
          customClass="bank-data-form-submit-btn"
          disabled={!valid}
          loading={loading}
          onClick={this.submitForm}
        >
          Agree and Continue
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  selectedOffer: selectedOfferSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

KafeneAgreement = connect(mapStateToProps, mapDistpatchToProps)(KafeneAgreement);

export default KafeneAgreement;
